import { SET_ACTIVE_PERIOD } from "./mutation_types";
import { Vueset } from "../../vuehack/reactivehack";
export default {
  [SET_ACTIVE_PERIOD](state, value) {
    Vueset(state, "activePeriod", value);
  }
};
